import { createFileRoute } from '@tanstack/react-router';

import { CommitteeCreate } from '@/module/Author/Committee/CommitteeCreate';

export const Route = createFileRoute('/_auth/author/_author/committee/_committee/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <CommitteeCreate />;
}
